import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA4_ID;

/**
 * Loads Google Analytics 4 (gtag.js) only when REACT_APP_GA4_ID is set,
 * and tracks SPA route changes as page views.
 */
export default function GA4() {
  const location = useLocation();

  useEffect(() => {
    if (!GA_ID || document.getElementById("ga4-script")) return;
    const s = document.createElement("script");
    s.id = "ga4-script";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID);
  }, []);

  useEffect(() => {
    if (!GA_ID || typeof window.gtag !== "function") return;
    window.gtag("config", GA_ID, { page_path: location.pathname });
  }, [location]);

  return null;
}
